import { RouterModule, Routes } from '@angular/router';
import { EditWorkspaceComponent } from './components/edit-workspace/edit-workspace.component';
import { NgModule } from '@angular/core';
import { CreateWorkspaceComponent } from './components/create-workspace/create-workspace.component';
import { WorkspaceCreationGuard } from './guards/workspace-creation.guard';
import { CanAccessWorkspace } from '../shared/guards/can-access-workspace';
import { canActivateWorkspaceSettings } from './guards/workspace-settings.guard';
import { provideMtmPermissionUI } from '../shared/permission/permission.providers';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
  },
  {
    path: 'new',
    component: CreateWorkspaceComponent,
    canActivate: [CanAccessWorkspace, WorkspaceCreationGuard],
  },
  {
    path: 'edit/:workspaceId',
    // Workspace settings (CORE_WORKSPACE update) or user/permission management (CORE_COMPANY
    // manage.users) — the permission-UI panel inside re-checks manage.users on its own.
    canActivate: [CanAccessWorkspace, canActivateWorkspaceSettings],
    component: EditWorkspaceComponent,
    // `providers` on the route (not on `WorkspaceModule`, which `AppModule` imports eagerly) so
    // `providePermissionUI()`'s internal `provideHttpClient()` lands in a child injector rather
    // than the root one — see `permission.providers.ts`.
    providers: [...provideMtmPermissionUI()],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkspaceRoutingModule {}
